import { Link } from 'react-router-dom';
import React, {useEffect, useState} from 'react';

import getFooterLinks from './footer-links'

function Footer({currentPage}) {
    const [currentYear, setCurrentYear] = useState('');

    const footerLinks = getFooterLinks();

    useEffect(() => {
        const d = new Date();
        setCurrentYear(d.getFullYear());
    }, [])

    return (
        <footer className="bg-background-dark border-t border-white/5 py-12">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
                    <div className="col-span-1 md:col-span-1">
                        <div className="flex items-center gap-3 mb-6">
                            <div className="size-6 bg-primary rounded flex items-center justify-center">
                                <span className="material-symbols-outlined text-white text-xs">speed</span>
                            </div>

                            <h1 className="text-lg font-bold tracking-tight text-white uppercase italic"><span className="text-primary">Live</span>Telemetry</h1>
                        </div>

                        <p className="text-slate-500 text-sm leading-relaxed">The gold standard in sim racing games telemetry. Built by sim racers, for sim racers.</p>
                    </div>

                    {footerLinks.map((item) => (
                        <div key={item.sectionName}>
                            <h6 className="text-white font-bold uppercase text-xs tracking-widest mb-6">{item.sectionName}</h6>

                            <ul className="space-y-3">
                                {item.links.map((page) => (
                                    <li key={page.link}><Link to={page.link}><button className={`${currentPage === page.text ? "text-primary" : "text-slate-400"} hover:text-primary text-sm transition-colors`}>{page.text}</button></Link></li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="pt-8 border-t border-white/5 flex flex-col md:row items-center justify-between gap-4">
                    <p className="text-slate-600 text-center text-[10px] uppercase font-bold tracking-widest">© {currentYear} ACCLiveTelemetry. Not affiliated with Kunos Simulazioni.</p>
                </div>
            </div>
        </footer>
    );
}

export default Footer;